import { useSearchParams } from "react-router-dom";
import MonthlySummary from "../../../../components/AssetManagement/Overview/PerformanceForecaster/ForeCasterInfo/MonthlySummary/MonthlySummary";
import FloatingActionItems from "../../../FloatingItems/FloatingActionItems";

const MonthlySummaryScreen = () => {
  const [searchParams] = useSearchParams();

  return (
    <>
      <MonthlySummary />
      <div data-tracker="399">
        <FloatingActionItems
          selectedSiteFloatingAction={
            searchParams.get("selectedSite") as string
          }
          selectedDimensionsFloatingAction={""}
          trackIdFloatingAction={"429"}
        />
      </div>
    </>
  );
};

export default MonthlySummaryScreen;
